import { ConfigFilenamePrefix } from './ConfigFilenamePrefix'
import { TagFilenamePrefix } from './TagFilenamePrefix'

export const FreewallFilenamePrefix = { ...ConfigFilenamePrefix, ...TagFilenamePrefix }
export type FreewallFilenamePrefix = ConfigFilenamePrefix | TagFilenamePrefix;
